export const ACTION_MAP = {
  create: 'created',
  update: 'updated',
  delete: 'deleted',
  upload: 'uploaded',
  cancel: 'canceled',
  reschedule: 'rescheduled',
  no_show: 'marked as no-show',
  restore: 'restored'
};
